import { INITIAL_STATE } from './initialState'
import { ChargingTokenTypes } from './Actions'
import { createReducer } from 'reduxsauce'
import RequestState from 'Enums/RequestState'
import IFFIlterType from 'Enums/IFFilterType'
import history from 'history/browser'
import { encodeObjectToBase64 } from '../../Utils/Base64Functions'
import InfinityEnums from 'Enums/InfinityEnums'

export const fetchChargingTokensLoading = (state) => {
  return {
    ...state,
    fetchChargingTokensRequestState: RequestState.LOADING,
  }
}

export const fetchChargingTokensSuccess = (
  state,
  { offset, chargingTokens, nextOffset, filterObject },
) => {
  let result = []
  for (let j = 0; j < chargingTokens.length; j++) {
    if (
      !state.chargingTokens.some(
        (chargingToken) => chargingToken._id === chargingTokens[j]._id,
      )
    ) {
      result.push(chargingTokens[j])
    }
  }

  const onChargingTokenPage =
    window.location.pathname.toLocaleLowerCase().indexOf('chargingtokens') !==
      -1 ||
    history.location.pathname.toLocaleLowerCase().indexOf('chargingtokens') !==
      -1

  if (onChargingTokenPage) {
    if (offset === 0) {
      return {
        ...state,
        chargingTokens: chargingTokens.map((chargingTokens) => ({
          ...chargingTokens,
        })),
        fetchChargingTokensRequestState: RequestState.SUCCEEDED,
        paginationOffset: nextOffset,
        chargingTokenFilter: filterObject,
      }
    } else {
      return {
        ...state,
        chargingTokens: [
          ...state.chargingTokens,
          ...result.map((chargingTokens) => ({
            ...chargingTokens,
          })),
        ],
        fetchChargingTokensRequestState: RequestState.SUCCEEDED,
        paginationOffset: nextOffset,
      }
    }
  } else {
    return {
      ...state,
      fetchChargingTokensRequestState: RequestState.UNINITIALIZED,
    }
  }
}

export const fetchChargingTokensError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchChargingTokensRequestState: requestState,
  }
}

export const editChargingTokenLoading = (state) => {
  return {
    ...state,
    editChargingTokenRequestState: RequestState.LOADING,
  }
}

export const editChargingTokenSuccess = (state, { chargingToken }) => {
  const updatedAppChragingToken = state.chargingTokens.map(
    (oldChargingToken) => {
      return oldChargingToken._id === chargingToken._id
        ? {
            ...oldChargingToken,
            huid: chargingToken.huid,
            contractId: chargingToken.contractId,
            design: chargingToken.design,
            reference: chargingToken.reference,
            parentId: chargingToken.parentId,
            voucherCode: chargingToken.voucherCode,
            voucherDetails: chargingToken.voucherDetails,
          }
        : oldChargingToken
    },
  )
  return {
    ...state,
    chargingTokens: updatedAppChragingToken,
    editChargingTokenRequestState: RequestState.SUCCEEDED,
  }
}

export const editChargingTokenError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    editChargingTokenRequestState: requestState,
  }
}

export const deleteChargingTokenLoading = (state) => {
  return {
    ...state,
    deleteChargingTokenRequestState: RequestState.LOADING,
  }
}
export const deleteChargingTokenSuccess = (state, { chargingTokenId }) => {
  const updatedChargingTokenList = state.chargingTokens.filter(
    (chargingToken) => chargingToken._id !== chargingTokenId,
  )
  return {
    ...state,
    chargingTokens: updatedChargingTokenList,
    deleteChargingTokenRequestState: RequestState.SUCCEEDED,
    count: state.count - 1 < 0 ? 0 : state.count - 1,
  }
}

export const deleteChargingTokenError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteChargingTokenRequestState: requestState,
  }
}

export const clearChargingTokens = (state) => {
  return {
    ...state,
    chargingTokens: [],
    fetchChargingTokensRequestState: RequestState.UNINITIALIZED,
  }
}
export const setDeleteChargingTokenRequestState = (state, { newState }) => {
  return {
    ...state,
    deleteChargingTokenRequestState: newState,
  }
}

export const createChargingTokenLoading = (state) => {
  return {
    ...state,
    createChargingTokenRequestState: RequestState.LOADING,
  }
}

export const createChargingTokenSuccess = (state, { chargingToken }) => {
  return {
    ...state,
    chargingTokens: [chargingToken, ...state.chargingTokens],
    createChargingTokenRequestState: RequestState.SUCCEEDED,
    count: state.count + 1,
  }
}

export const createChargingTokenError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    createChargingTokenRequestState: requestState,
  }
}

export const createChargingTokenBulkLoading = (state) => {
  return {
    ...state,
    createChargingTokenBulkRequestState: RequestState.LOADING,
  }
}
export const createChargingTokenBulkSuccess = (state, { chargingTokens }) => {
  return {
    ...state,
    chargingTokens: [...chargingTokens, ...(state.chargingTokens || [])],
    createChargingTokenBulkRequestState: RequestState.SUCCEEDED,
    count: state.count + chargingTokens.length,
  }
}
export const createChargingTokenBulkError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    createChargingTokenBulkRequestState: requestState,
  }
}

export const downloadChargingTokenSampleFileLoading = (state) => {
  return {
    ...state,
    downloadChargingTokenSampleFileRequestState: RequestState.LOADING,
  }
}

export const downloadChargingTokenSampleFileSuccess = (state) => {
  return {
    ...state,
    downloadChargingTokenSampleFileRequestState: RequestState.SUCCEEDED,
  }
}

export const downloadChargingTokenSampleFileError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    downloadChargingTokenSampleFileRequestState: requestState,
  }
}
export const getChargingTokensCountLoading = (state) => {
  return {
    ...state,
    getChargingTokensCountRequestState: RequestState.LOADING,
  }
}
export const getChargingTokensCountSuccess = (state, { count }) => {
  return {
    ...state,
    count: count,
    getChargingTokensCountRequestState: RequestState.SUCCEEDED,
  }
}
export const getChargingTokensCountError = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    getChargingTokensCountRequestState: requestState,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [ChargingTokenTypes.FETCH_CHARGING_TOKENS_LOADING]:
    fetchChargingTokensLoading,
  [ChargingTokenTypes.FETCH_CHARGING_TOKENS_SUCCESS]:
    fetchChargingTokensSuccess,
  [ChargingTokenTypes.FETCH_CHARGING_TOKENS_ERROR]: fetchChargingTokensError,
  [ChargingTokenTypes.EDIT_CHARGING_TOKEN_LOADING]: editChargingTokenLoading,
  [ChargingTokenTypes.EDIT_CHARGING_TOKEN_SUCCESS]: editChargingTokenSuccess,
  [ChargingTokenTypes.EDIT_CHARGING_TOKEN_ERROR]: editChargingTokenError,
  [ChargingTokenTypes.DELETE_CHARGING_TOKEN_LOADING]:
    deleteChargingTokenLoading,
  [ChargingTokenTypes.DELETE_CHARGING_TOKEN_SUCCESS]:
    deleteChargingTokenSuccess,
  [ChargingTokenTypes.DELETE_CHARGING_TOKEN_ERROR]: deleteChargingTokenError,
  [ChargingTokenTypes.CLEAR_CHARGING_TOKENS]: clearChargingTokens,
  [ChargingTokenTypes.SET_DELETE_CHARGING_TOKEN_REQUEST_STATE]:
    setDeleteChargingTokenRequestState,
  [ChargingTokenTypes.CREATE_CHARGING_TOKEN_LOADING]:
    createChargingTokenLoading,
  [ChargingTokenTypes.CREATE_CHARGING_TOKEN_SUCCESS]:
    createChargingTokenSuccess,
  [ChargingTokenTypes.CREATE_CHARGING_TOKEN_ERROR]: createChargingTokenError,
  [ChargingTokenTypes.CREATE_CHARGING_TOKEN_BULK_LOADING]:
    createChargingTokenBulkLoading,
  [ChargingTokenTypes.CREATE_CHARGING_TOKEN_BULK_SUCCESS]:
    createChargingTokenBulkSuccess,
  [ChargingTokenTypes.CREATE_CHARGING_TOKEN_BULK_ERROR]:
    createChargingTokenBulkError,
  [ChargingTokenTypes.DOWNLOAD_CHARGING_TOKEN_SAMPLE_FILE_LOADING]:
    downloadChargingTokenSampleFileLoading,
  [ChargingTokenTypes.DOWNLOAD_CHARGING_TOKEN_SAMPLE_FILE_SUCCESS]:
    downloadChargingTokenSampleFileSuccess,
  [ChargingTokenTypes.DOWNLOAD_CHARGING_TOKEN_SAMPLE_FILE_ERROR]:
    downloadChargingTokenSampleFileError,
  [ChargingTokenTypes.GET_CHARGING_TOKENS_COUNT_LOADING]:
    getChargingTokensCountLoading,
  [ChargingTokenTypes.GET_CHARGING_TOKENS_COUNT_SUCCESS]:
    getChargingTokensCountSuccess,
  [ChargingTokenTypes.GET_CHARGING_TOKENS_COUNT_ERROR]:
    getChargingTokensCountError,
})
